export const state = {
  loading: false,
  lastTime: null,
}

export const getters = {
  getLoading(state) {
    return null
  },
}

export const mutations = {
  SHOW_LOADING(state, time) {
    state.loading = true
    state.lastTime = time
  },
  HIDE_LOADING(state, time) {
    if (time === state.lastTime) {
      state.loading = false
    }
  },
}

export const actions = {
  showLoading({ commit }, time) {
    commit('SHOW_LOADING', time)
  },
  hideLoading({ commit }, time) {
    setTimeout(() => {
      commit('HIDE_LOADING', time)
    }, 500)
  },
}
